import { useTranslation } from '@mint-lib/i18n';
import { useQueryClient } from '@mint-lib/query-client';
import { Button } from '@mint-lib/tw-components';
import { Alert } from '@mint-lib/tw-components/patterns';

const ApprovalFlowTabError = () => {
  const { t } = useTranslation('@mint-lib/approval-flow-circuit_v2');
  const queryClient = useQueryClient();

  const handleRetry = () => {
    queryClient.resetQueries({
      queryKey: ['approval-flow-circuit_v2', 'listFlows'], //TODO: use invalidate from the real query
    });
  };

  return (
    <Alert
      severity="error"
      title={t('Failed to retrieve the list of flows.')}
      variant="inline"
      removable={false}
      onClick={handleRetry}
    >
      <Button
        data-dd-action-name="Retry action"
        size="small"
        variant="outlined"
        type="button"
        onClick={() => {}}
      >
        {t('Try again')}
      </Button>
    </Alert>
  );
};

export default ApprovalFlowTabError;
